module.exports = __webpack_public_path__ + "static/media/centro_comercial_ciudad_jardin.669ab574.jpg";